var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"automated-po-overview pa-0",attrs:{"fluid":""}},[_c('hero-section'),_c('workflow-diagram'),_c('benefits-grid'),_c('quick-actions'),_c('help-resources')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }